import { Controller } from "@hotwired/stimulus"

// Validates that the response schema textarea contains valid JSON.
// Provider-specific schema constraints are handled by backend sanitizers
// at runtime (sanitize_schema_for_anthropic, sanitize_schema_for_openai,
// sanitize_schema_for_gemini), so the UI only needs to catch syntax errors.
export default class extends Controller {
  static targets = ["schemaField", "errors"]
  static values = {
    delay: { type: Number, default: 400 },
  }

  connect() {
    this.timer = null
    this.validate()
  }

  disconnect() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }

  schedule() {
    if (this.timer) clearTimeout(this.timer)
    this.timer = setTimeout(() => this.validate(), this.delayValue)
  }

  validate() {
    const textarea = this.hasSchemaFieldTarget ? this.schemaFieldTarget : null
    const errorsEl = this.hasErrorsTarget ? this.errorsTarget : null
    if (!textarea || !errorsEl) return

    const raw = textarea.value.trim()
    if (!raw) {
      errorsEl.innerHTML = ""
      errorsEl.classList.add("hidden")
      return
    }

    let schema
    try {
      schema = JSON.parse(raw)
    } catch (e) {
      this.renderError(errorsEl, `Invalid JSON: ${e.message}`)
      return
    }

    if (typeof schema !== "object" || schema === null || Array.isArray(schema)) {
      this.renderError(errorsEl, "Schema must be a JSON object")
      return
    }

    errorsEl.innerHTML = ""
    errorsEl.classList.add("hidden")
  }

  renderError(el, message) {
    el.innerHTML =
      `<div class="p-3 rounded border border-alert-red-300 bg-alert-red-200 text-alert-red-700 text-sm">` +
      `<span class="font-medium">JSON error:</span> ${this.escapeHtml(message)}` +
      `</div>`
    el.classList.remove("hidden")
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
